const FallbackLoading = () => {
  return (
		<div className="wait">
      <div className="loader-load">
        <div className="loader__ball"></div>
        <div className="loader__ball"></div>
        <div className="loader__ball"></div>
      </div>
    </div>
  )
}

export default FallbackLoading
